export default __webpack_public_path__ + "logo_en_new.c1725330.svg";